import React, { useEffect } from "react";
import GoogleReCAPTCHA from "react-google-recaptcha";

type Props = {
    captchaRef: any;
    hideBadge: boolean;
}

export default function ReCaptcha(props: Props) {
    const { captchaRef, hideBadge } = props;
    const [loaded, setLoaded] = React.useState(false);

    useEffect(() => {
        if (loaded && hideBadge) {
            const elements = document.getElementsByClassName("grecaptcha-badge");

            if (elements.length > 0) {
                const badge = elements[0] as HTMLDivElement;

                badge.style.setProperty("visibility", "hidden");
            }
        }
    }, [loaded, hideBadge]);

    return (
        <GoogleReCAPTCHA
            size="invisible"
            ref={captchaRef}
            sitekey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
            asyncScriptOnLoad={() => setLoaded(true)}
        />
    );
};